export default import.meta.ROLLUP_FILE_URL_DzYsnjr1LtW1tBWqsYm2RQ;